import React, {Component} from 'react';
import {translate} from 'react-i18next';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import {Typeahead} from 'react-bootstrap-typeahead';
import swal from 'sweetalert';
import {FormGroup, Table, Button} from 'react-bootstrap';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import {bin} from 'react-icons-kit/icomoon/bin';
import SvgIcon from 'react-icons-kit';
import $ from 'jquery';

const Config = require('../../../config');

class EntriesPlasmaticForm extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.blurInput = this.blurInput.bind(this);
		this.addProduct = this.addProduct.bind(this);
		this.onCancel = this.onCancel.bind(this);
		this.onSave = this.onSave.bind(this);
		this.removeUnitFromList = this.removeUnitFromList.bind(this);
		this.getTimeServer = this.getTimeServer.bind(this);

		this.state = {
			entry_date:"",
			purchase_folio:"",
			purchase_date:"",
			plasmatic_provider:"",
			plasmatic_distributor:"",
			plasmatic_products_purchase_details:[],
			tbl_products:[],
			
			plasmatic_product_id:"",
			lot_number:"",
			amount:"",
			expiration_date:"",
			cost_unit_entry:"",
			subtotal:"",

			providers:[],

			distribuitors:[],

			products:[],
			loading_product:false,
			product_selected:[],
			index_product:-1,
			valid_prod:"",
		}
	}

	validInputDate(message, id){
		if(message !== ""){
			swal('Error', message, 'error');
			
			setTimeout(()=>{
				$('#'+id).val('')
					.attr('type', 'text')
					.attr('type', 'date');
			}, 4000);

			$('#'+id).addClass('error');
		}else{
			$('#'+id).removeClass('error');
		}
	}

	componentDidMount(){
		$(document).on('blur', '#purchase_date', (e)=>{
			this.validInputDate(e.target.validationMessage, e.target.id);
		});

		$(document).on('blur', '#expiration_date', (e)=>{
			this.validInputDate(e.target.validationMessage, e.target.id);
		});
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'lookups?type=DISTRIBUTOR&option=actives&order=true', {
			method:'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({distribuitors:response});
			}
		});

		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'lookups?type=MAKER&option=actives&order=true', {
			method:'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({providers:response});
			}
		});

		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'plasmatic_product?option=actives', {
			method:'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({products:response});
			}
		});

		this.getTimeServer();
	}

	getTimeServer(){
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split('/').reverse().join('-')

			this.setState({
				entry_date:date,
			});

		})
	}

	handleChange(e){
		var campo = e.target.name;
		this.setState({
			[campo]: e.target.value
		});

		if(e.target.value !== ""){

			setTimeout(()=>{
				this.showCtrlError(campo);
			}, 300);
			
		}
	}

	handleTypeAheadChange = name => values => {

        if(values.length > 0){
        	if(name === 'product'){
        		this.setState({loading_product:true});

        		setTimeout(()=>{
        			this.setState({
						index_product:0,
						product_selected:values,
						amount:1,
						cost_unit_entry:values[0].cost_unit,
						loading_product:false,
						plasmatic_product_id:values[0].id,
						valid_prod: ''
				    });

				    this._typeahead_product.getInstance().blur();
				    document.getElementById('lot_number').focus();

				    this.errorAutoComplete('product');
        		}, 1000);
	        		
        	}
        	
        }
    }

    blurInput(e) {
	    const re = /^[-+]?$/;
	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);
      		if(form.elements[index + 1] !== undefined){
      			form.elements[index + 1].focus();
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	addProduct(e){
  		if(this.validate('details')){
  			var subtotal = parseFloat(this.state.amount) * (
  							(this.state.cost_unit_entry !== '' && this.state.cost_unit_entry !== null) ?	parseFloat(this.state.cost_unit_entry) : 0
							  );

  			var index = this.state.tbl_products.findIndex(obj => 
  				obj.plasmatic_product_id === this.state.plasmatic_product_id &&
  				obj.lot_number === this.state.lot_number //&&
  				//obj.expiration_date === moment(this.state.expiration_date).format('DD/MM/YYYY')
  			);

  			if(index === -1){
  				this.setState({
	  				tbl_products:[
	  					...this.state.tbl_products,
	  					{
	  						plasmatic_product_id:this.state.plasmatic_product_id,
	  						name:this.state.product_selected[0].name,
							lot_number:this.state.lot_number,
							amount:this.state.amount,
							expiration_date:moment(this.state.expiration_date).format('DD/MM/YYYY'),
							cost_unit_entry:this.state.cost_unit_entry !== '' && this.state.cost_unit_entry !== null ?
											 parseFloat(this.state.cost_unit_entry).toFixed(2) : '',
							subtotal:subtotal.toFixed(2)
	  					}
	  				],

	  				plasmatic_product_id:"",
					lot_number:"",
					amount:"",
					expiration_date:"",
					cost_unit_entry:"",
					subtotal:"",
					loading_product:false,
					product_selected:[],
					index_product:-1,
					valid_prod:"",
	  			});
  			}else{
  				swal('Error', 'El producto no puede tener el mismo lote con diferente fecha de caducidad', 'error');
  			}

	  			
  		}else{
  			swal('Error', 'Campos Incompletos', 'error');
  		}
  	}

  	validate(section){
  		const select = document.querySelector('div.'+section);
   		const inputs = select.querySelectorAll('input,select');
   		let isFormValid = true;

   		inputs.forEach(input => {
	    	if(input.required){

    			if(input.id === 'product'){
	    			isFormValid = this.errorAutoComplete(input.id);
	    		}else{
	    			const isInputValid = this.showCtrlError(input.name);
			      	if (!isInputValid) {
			        	isFormValid = false;
			    	}
	    		}   
		  	}
	    });
	    
	    return isFormValid;
  	}

  	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	errorAutoComplete(name){
		const length = name === 'product' ? this.state.plasmatic_product_id.length :
						name === 'provider' ? this.state.provider_selected.length :  this.state[name].length;
		let isFormValid = true;
		if (length === 0){
			if(name==='product'){
				this.setState({valid_prod:'error'});
				isFormValid = false;
			}else if(name==='provider'){
				this.setState({valid_prov:'error'});
				isFormValid = false;
			}
		}else{
			if(name==='product'){
				this.setState({valid_prod:''});

			}else if(name==='provider'){
				this.setState({valid_prov:''});
			}

			
		}
	
		return isFormValid;
	}

	onCancel(){
		this.props.history.push('/entries_plasmatic_products');
	}

	onSave(){
		if(this.validate('entries')){
			var obj = {
				entry_date:moment(this.state.entry_date).format('MM-DD-YYYY'),
				purchase_folio:this.state.purchase_folio,
				purchase_date:this.state.purchase_date !== "" ? moment(this.state.purchase_date).format('MM-DD-YYYY') : "",
				plasmatic_provider: this.state.plasmatic_provider,
				plasmatic_distributor: this.state.plasmatic_distributor,
				plasmatic_products_purchase_details:[],
				health_facilities_id:sessionStorage.getItem('health_facilities_id')
			
			}

			if(this.state.tbl_products.length > 0){
				this.state.tbl_products.map((t)=>{
					obj.plasmatic_products_purchase_details.push({
						plasmatic_product_id:t.plasmatic_product_id,
						lot_number:t.lot_number,
						amount:t.amount,
						expiration_date:moment(t.expiration_date, 'DD/MM/YYYY').format('MM-DD-YYYY'),
						cost_unit_entry:t.cost_unit_entry !== '' ? parseFloat(t.cost_unit_entry).toFixed(2) : '',
						code:""
					})
				})
				this.props.waiting.handleShow('Guardando...');
				fetch(Config.default.apiGateway.URL+'plasmatic_product_purschase', {
					method:'POST',
					body: JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						swal('Proceso Terminado', 'La entrada se guardo correctamente', 'success');
						this.props.history.push('/entries_plasmatic_products');
					}
				});

			}else{
				swal({
		          	title: "Error",
		          	text: 'Debe Ingresar por lo menos un producto',
		          	type: 'error',
		        }, (isConfirm)=>{
		            if (isConfirm) {
		            	setTimeout(()=>{
							this._typeahead_product.getInstance().focus();
		            	}, 500);
		             	
		            }else{
		              	return false;
		            }
		        });

				
			}
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	removeUnitFromList = (indice) => {
		var array = [...this.state.tbl_products];
		array.splice(indice, 1);
		this.setState({tbl_products: array});
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						Productos Hemostáticos ->
						Nueva Entrada  
					</h5>
				</div>

				<form noValidate>
					<fieldset className="col-xs-12">
						<legend>Entrada</legend>
						<div className="col-xs-12 entries">
							<div className="col-xs-12 col-sm-2">
								<span className="span-min">F. Entrada</span>
								<input type="date" className="form-control" name="entry_date" id="entry_date"
									value={this.state.entry_date} onChange={this.handleChange}
									onKeyPress={this.blurInput} disabled/>
							</div>
							<div className="col-xs-12 col-sm-2">
								<span className="span-min">Folio Factura</span>
								<input type="text" className="form-control" name="purchase_folio" id="purchase_folio"
									value={this.state.purchase_folio} onChange={this.handleChange}
									onKeyPress={this.blurInput} />
							</div>

							<div className="col-xs-12 col-sm-2">
								<span className="span-min">F. Factura</span>
								<input type="date" className="form-control" name="purchase_date" id="purchase_date"
									value={this.state.purchase_date} onChange={this.handleChange} 
									onKeyPress={this.blurInput} />
							</div>

							<div className="col-xs-12 col-sm-3">
								<span className="span-min">Fabricante</span>
								<select className="form-control" name="plasmatic_provider" id="plasmatic_provider" 
									onChange={this.handleChange} value={this.state.plasmatic_provider}
									required>
									<option value="">Seleccione...</option>
									{this.state.providers.map((p, i)=>(
										<option key={i} value={p.key}>
											{p.name}
										</option>
									))}
								</select>
							</div>

							<div className="col-xs-12 col-sm-3">
								<span className="span-min">Distribuidor</span>

								<select className="form-control" name="plasmatic_distributor" id="plasmatic_distributor" 
									onChange={this.handleChange} value={this.state.plasmatic_distributor}
									required>
									<option value="">Seleccione...</option>
									{this.state.distribuitors.map((d, i)=>(
										<option key={i} value={d.key}>
											{d.name}
										</option>
									))}
								</select>
							</div>
						</div>
					</fieldset>

					<fieldset className="col-xs-12">
						<legend>Detalles</legend>
						<div className="col-xs-12 form-group details">
							<div className="col-xs-12 col-sm-4">
								<FormGroup id="valid_prod" validationState={this.state.valid_prod || null} 
									style={{marginBottom:"0px"}}>
									<span className="span-min">Producto</span>
									<Typeahead
							          	labelKey={(option) => (`${option.name}`)}
							          	minLength={0}
							          	options={this.state.products.length > 0 ? this.state.products : []}
							          	onChange={this.handleTypeAheadChange('product')}	
							            inputProps={{
							          		name:"product",
							          		id:"product",
							          		autoComplete:"off",
							          		required:true
							          	}}
							          	id="auto_product"
							          	isLoading={this.state.loading_product}
							          	useCache={false}
							          	ref={ref => this._typeahead_product = ref}
							          	defaultSelected={this.state.products.slice(this.state.index_product, 1)}
							          	selected={this.state.product_selected}
							          	selectHintOnEnter={true}
							          	delay={600}
							          	paginationText="Mostrar mas resultados..."
							        />
							    </FormGroup>
							</div>
							<div className="col-xs-12 col-sm-1">
								<span className="span-min">Lote</span>
								<input type="text" className="form-control" name="lot_number" id="lot_number"
									value={this.state.lot_number} onChange={this.handleChange} 
									onKeyPress={this.blurInput} required/>
							</div>

							<div className="col-xs-12 col-sm-1">
								<span className="span-min">Cantidad</span>
								<input type="number" className="form-control hour-input" name="amount" id="amount"
									value={this.state.amount} onChange={this.handleChange} 
									onKeyPress={this.blurInput} required/>
							</div>

							<div className="col-xs-12 col-sm-1">
								<span className="span-min">Caducidad</span>
								<input type="date" className="form-control hour-input" name="expiration_date" id="expiration_date"
									value={this.state.expiration_date} onChange={this.handleChange}
									onKeyPress={this.blurInput} required />
							</div>

							<div className="col-xs-12 col-sm-1">
								<span className="span-min">Costo</span>
								<input type="text" className="form-control" name="cost_unit_entry" id="cost_unit_entry"
									value={this.state.cost_unit_entry} onChange={this.handleChange}
									onKeyPress={this.blurInput} />
							</div>
							<div className="col-xs-12 col-sm-1">
								<FloatingActionButton className="action-btn" mini={true} onClick={this.addProduct} >
			                      <ContentAdd/>
			                    </FloatingActionButton> 
							</div>
						</div>

						<div className="col-xs-12">
							<Table responsive hover>
								<thead>
									<tr>
										<th>Producto</th>
										<th>Lote</th>
										<th>Cantidad</th>
										<th>Caducidad</th>
										<th>Costo</th>
										<th>Subtotal</th>
										<th></th>
									</tr>
								</thead>
								<tbody>
									{this.state.tbl_products.map((t, i)=>(
										<tr key={i}>
											<td>{t.name}</td>
											<td>{t.lot_number}</td>
											<td>{t.amount}</td>
											<td>{t.expiration_date}</td>
											<td>{t.cost_unit_entry !== '' ? '$ '+t.cost_unit_entry : ''}</td>
											<td>{t.subtotal > 0 ? '$ '+t.subtotal : ''}</td>
											<td>
												<Button className="btn btn-info btn-xs" title="Eliminar" 
													style={{marginRight:'3px'}} 
													onClick={(e) => this.removeUnitFromList(e, i)}>
						                            <SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
						                        </Button>
											</td>
										</tr>
									))}
								</tbody>
							</Table>	
						</div>


					</fieldset>

					<div className="col-xs-12" style={{textAlign:'center'}}>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} 
		        			onClick={this.onSave}  style={{margin:12}}/>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} 
		        			style={{margin:12}} onClick={this.onCancel}/>
			        	
			        </div>

				</form>
				

			</div>
		)
	}

}

export default translate('translations')(EntriesPlasmaticForm);